import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import parse from "html-react-parser";
import { Link } from "@base-ui";
import { StyledContainer, styledSystemKeys } from "./formattedText.styles";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { extendedSystemStylesProps } from "@mixins";
import { isExternalLink } from "utils/links";
import { jsx as _jsx } from "react/jsx-runtime";
export default function (props) {
  var _JSON$parse;
  var delta = props.delta,
    inverted = props.inverted,
    className = props.className;
  var ops = delta && ((_JSON$parse = JSON.parse(delta)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.ops) || [];
  var converter = new QuillDeltaToHtmlConverter(ops);
  var markup = parse(converter.convert(), {
    replace: function replace(node) {
      var _node$parent;
      if (node.name === "a" && node.attribs.href) {
        var _node$prev, _node$next;
        var children = node.children.map(function (child) {
          return child.data;
        });
        var newLine = (((_node$prev = node.prev) === null || _node$prev === void 0 ? void 0 : _node$prev.name) === "br" || !node.prev) && (((_node$next = node.next) === null || _node$next === void 0 ? void 0 : _node$next.name) === "br" || !node.next);
        var external = isExternalLink(node.attribs.href);
        return /*#__PURE__*/_jsx(Link, {
          as: external ? "a" : undefined,
          to: !external ? node.attribs.href.split(location.host).pop() : "",
          href: external ? node.attribs.href : undefined,
          inverted: inverted ? "true" : "",
          target: external ? node.attribs.target : undefined,
          rel: external && node.attribs.target === "_blank" ? "noreferrer" : undefined,
          display: "inline-flex",
          p: !newLine ? 0 : "",
          style: {
            minHeight: !newLine ? "36px" : ""
          },
          ml: newLine ? "-20px" : "",
          children: children
        });
      } else if (((_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.name) === "a") return null;
      return node;
    }
  });
  return /*#__PURE__*/_jsx(StyledContainer, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    inverted: inverted,
    children: markup
  }));
}